import { UpdateBlockLayerCommand } from '../../UndoRedo/UpdateBlockLayerCommand.ts';
import { UndoRedoManagerCommandVersion } from '../../UndoRedo/UndoRedoManagerCommandVersion.ts';
import { useCurrentUser } from '../../../../providers/UserProvider.tsx';
import { useAppDispatch } from '../../grid/reduxStore/Store.ts';
import { useSocketClient } from '../../../../providers/SocketContext.tsx';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { useSectionId } from '../../Sections/SectionIdProvider.tsx';
import { useSectionData } from '../../Sections/useSectionContext.ts';

export const useNewBlockLayerChangeHandler = () => {
  const dispatch = useAppDispatch();
  const { data } = useCurrentUser();
  const userId = data.id;
  const { socketClient } = useSocketClient();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const sectionId = useSectionId();
  const sectionData = useSectionData();

  const deps = { dispatch, socketClient, userId, checkDocumentLockStatus };

  const changeLayerForBlock = async ({ blockId, zIndex }: { blockId: string; zIndex: number }) => {
    const previousZIndex = sectionData.blocksContent[blockId]?.blockConfig.z ?? 0;
    const command = new UpdateBlockLayerCommand(sectionId, [{ blockId, previousZIndex, newZIndex: zIndex }], deps);
    const success = await command.redo();
    if (success) UndoRedoManagerCommandVersion.getUndoRedoManager().pushUndoRedoCommands(command);
  };

  const recordTransaction = async (changes: { blockId: string; zIndex: number }[]) => {
    const transactions = changes.map(({ blockId, zIndex }) => ({
      blockId,
      previousZIndex: sectionData.blocksContent[blockId]?.blockConfig.z ?? 0,
      newZIndex: zIndex,
    }));
    const command = new UpdateBlockLayerCommand(sectionId, transactions, deps);
    const success = await command.redo();
    if (success) UndoRedoManagerCommandVersion.getUndoRedoManager().pushUndoRedoCommands(command);
  };

  return { changeLayerForBlock, recordTransaction };
};
